/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "product",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "priceType",
                type: "uint8",
            },
        ],
        name: "latestAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct PythStructs.UpgradeContract",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "attestPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "pa",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyPythVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedPriceAttestation",
                type: "bytes",
            },
        ],
        name: "parsePriceAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "pa",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "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";
var Pyth__factory = /** @class */ (function (_super) {
    __extends(Pyth__factory, _super);
    function Pyth__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Pyth__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    Pyth__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    Pyth__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Pyth__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Pyth__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    Pyth__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    Pyth__factory.bytecode = _bytecode;
    Pyth__factory.abi = _abi;
    return Pyth__factory;
}(ContractFactory));
export { Pyth__factory };
